function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id"],
  _excluded2 = ["id", "additionalIds"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint consistent-return: 0 */
import merge from 'lodash/merge';
import { isString } from './utils';
import deviceDefaults from './device-defaults';
export function sdrn(id) {
  return "sdrn:schibsted:environment:".concat(id);
}

/**
 * Device Input
 *
 * The values in `id` and `additionalIds` will be transformed to a valid ID
 * according to schema. Other values are passed on as is.
 */

/**
 * A correct schema representation of a Device
 */

function formatDeviceInput(input) {
  if (isString(input)) {
    return {
      id: input
    };
  }
  var _ref = input || {},
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    id: id
  }, rest);
}

/**
 * Generate a device representation
 *
 * Several default values are used in a browser environment: acceptLanguage,
 * screenSize, userAgent, deviceType, viewportSize, localStorageEnabled. See
 * (device-browser.js)[device-browser.js] for implementation details.
 *
 * The browser implementation will also read the required values from the
 * `_pulse2cookie` and if needed sync with CIS. Note that *this is not
 * implemented for Node.js environments*. There are no default values in
 * Node.js.
 */
export default function device(data) {
  var _ref2 = data || {},
    deviceData = _ref2.device;
  var defaults = deviceDefaults();
  var input = merge({}, defaults, formatDeviceInput(deviceData));
  var id = input.id,
    additionalIds = input.additionalIds,
    props = _objectWithoutProperties(input, _excluded2);
  if (!id) {
    return undefined;
  }
  var baseDevice = {
    '@type': 'Device',
    environmentId: sdrn(id)
  };
  if (additionalIds) {
    baseDevice.additionalEnvironmentIds = additionalIds.map(sdrn);
  }
  return Object.assign(baseDevice, props);
}
export var defaultValue = deviceDefaults;